import { render, staticRenderFns } from "./FormAddCategory.vue?vue&type=template&id=443c1aec&scoped=true"
import script from "./FormAddCategory.vue?vue&type=script&lang=js"
export * from "./FormAddCategory.vue?vue&type=script&lang=js"
import style0 from "./FormAddCategory.vue?vue&type=style&index=0&id=443c1aec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443c1aec",
  null
  
)

export default component.exports